import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {borderRadius, mb, p} from "@pg-design/helpers-css";
import {DownloadIcon} from "@pg-design/icons-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {useABTest} from "@pg-mono/ab-testing";

import {abTestingInstance} from "../../../ab_testing/ab_testing_instance";
import {OngoingABTests} from "../../../ab_testing/ongoing_ab_tests";
import {ArticleAttachmentModalButton} from "./ArticleAttachmentModalButton";

interface IProps {
    article: {
        attachments: {
            file: string;
            title: string;
            id: number;
        }[];
    };
}

export const abTestInstance = abTestingInstance.getABTestContainerProps(OngoingABTests.ARTICLE_ATTACHMENT_PAYWALL);

export const ArticleAttachment: React.FC<IProps> = (props) => {
    const {abTestVariant} = useABTest(abTestInstance);

    return props.article.attachments.length > 0 ? (
        <div css={[articleAttachment]}>
            <Text mb="1.2rem" variant="headline_4" as="div" fontFamily="secondary">
                Załącznik do pobrania
            </Text>

            <ul css={listHolder}>
                {props.article.attachments.map(({id, title, file}) => {
                    return (
                        <li key={id} css={downloadItem}>
                            {abTestVariant === 0 ? (
                                <>
                                    <Text as="div" variant="body_copy_2">
                                        {title}
                                    </Text>
                                    <DownloadIcon size="2.4" wrapperSize="2.4" wrapperColor={getThemeVariable("colors.primary")} css={showOnMobile} />
                                    <Button href={file} target="_blank" iconLeft={DownloadIcon} variant="filled_primary" css={showOnDesktop} type="button">
                                        <span>Pobierz</span>
                                    </Button>
                                </>
                            ) : (
                                <ArticleAttachmentModalButton attachmentId={id} attachmentLink={file} title={title} />
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    ) : null;
};

const articleAttachment = css`
    ${p(4)};
    ${borderRadius(2)};
    ${mb(2)};
    background-color: #fff;
`;

const downloadItem = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${mb(2)};
`;

const listHolder = css`
    padding: 0;
    margin: 0;
    list-style: none;
`;

const showOnDesktop = css`
    display: none;

    @media (min-width: ${getThemeBreakpoint().md}) {
        display: block;
    }
`;

const showOnMobile = css`
    display: block;

    @media (min-width: ${getThemeBreakpoint().md}) {
        display: none;
    }
`;
import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {borderRadius, mb, p} from "@pg-design/helpers-css";
import {DownloadIcon} from "@pg-design/icons-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {useABTest} from "@pg-mono/ab-testing";

import {abTestingInstance} from "../../../ab_testing/ab_testing_instance";
import {OngoingABTests} from "../../../ab_testing/ongoing_ab_tests";
import {ArticleAttachmentModalButton} from "./ArticleAttachmentModalButton";

interface IProps {
    article: {
        attachments: {
            file: string;
            title: string;
            id: number;
        }[];
    };
}

export const abTestInstance = abTestingInstance.getABTestContainerProps(OngoingABTests.ARTICLE_ATTACHMENT_PAYWALL);

export const ArticleAttachment: React.FC<IProps> = (props) => {
    const {abTestVariant} = useABTest(abTestInstance);

    return props.article.attachments.length > 0 ? (
        <div css={[articleAttachment]}>
            <Text mb="1.2rem" variant="headline_4" as="div" fontFamily="secondary">
                Załącznik do pobrania
            </Text>

            <ul css={listHolder}>
                {props.article.attachments.map(({id, title, file}) => {
                    return (
                        <li key={id} css={downloadItem}>
                            {abTestVariant === 0 ? (
                                <>
                                    <Text as="div" variant="body_copy_2">
                                        {title}
                                    </Text>
                                    <DownloadIcon size="2.4" wrapperSize="2.4" wrapperColor={getThemeVariable("colors.primary")} css={showOnMobile} />
                                    <Button href={file} target="_blank" iconLeft={DownloadIcon} variant="filled_primary" css={showOnDesktop} type="button">
                                        <span>Pobierz</span>
                                    </Button>
                                </>
                            ) : (
                                <ArticleAttachmentModalButton attachmentId={id} attachmentLink={file} title={title} />
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    ) : null;
};

const articleAttachment = css`
    ${p(4)};
    ${borderRadius(2)};
    ${mb(2)};
    background-color: #fff;
`;

const downloadItem = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${mb(2)};
`;

const listHolder = css`
    padding: 0;
    margin: 0;
    list-style: none;
`;

const showOnDesktop = css`
    display: none;

    @media (min-width: ${getThemeBreakpoint().md}) {
        display: block;
    }
`;

const showOnMobile = css`
    display: block;

    @media (min-width: ${getThemeBreakpoint().md}) {
        display: none;
    }
`;
